// extracted by mini-css-extract-plugin
export default {"printElement":"price-label_printElement__a2lH3","hideElement":"price-label_hideElement__KA47q","noBorder":"price-label_noBorder__I8u6u","editBtn":"price-label_editBtn__MC0si"};